<div class="product-small">
  <div class="link" *ngIf="product" [routerLink]="['/product', product.ean, product.slugify()]">
    <div class="product-image"><img src="{{ product.getDefaultImage()?.url }}" alt="{{ product.name }}"></div>
    <h3>{{ product.getNameOrCommercialName() }}</h3>
    <div class="price">{{ product.price | price }}</div>
  </div>
</div>
<ngx-ui-loader [loaderId]="'loader-product-' + pId" [fgsType]="loaderType" [logoUrl]="null"></ngx-ui-loader>
